import type { FC, ReactNode } from "react";

import { TooltipIntent } from "../Tooltip/settings.ts";
import style from "./InfoToggletip.module.css";
import { InfoToggletip } from "./InfoToggletip.tsx";

export interface ProtectedToggletipProps {
  title?: string;
  content: ReactNode;
}

/**
 * A red protected icon with a popover tooltip.
 */
export const ProtectedToggletip: FC<ProtectedToggletipProps> = (props) => {
  return <InfoToggletip {...props} icon="security" iconClassName={style.dangerIcon} intent={TooltipIntent.Danger} />;
};
